import { render, staticRenderFns } from "./TheSnapshotQueryPreviewTable.vue?vue&type=template&id=4ea7264a&"
import script from "./TheSnapshotQueryPreviewTable.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotQueryPreviewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports